// extracted by mini-css-extract-plugin
export default {"tokenTextLarge":"IssueTypeToken-module__tokenTextLarge--xMEa6","container":"IssueTypeToken-module__container--bGRt0"};